const { default: axios } = require('axios')

const instance = axios.create({
  baseURL: 'https://api.datablockai.com/api/v1',
  headers: { 'Content-Type': 'application/json' },
})

export const getAIScoreForDemo = args => instance.post('/gec/ai-report', args)

export const getDemoBotResponse = (args, headers) => instance.post('/gec/learning-coach', args, headers)

export const getFactorialLessonData = args => instance.post('/ai/process', args)

export const generateLessonSummary = args => instance.post('/lesson-summary/generate', args)

export const parsePdfFile = args => instance.post('/gec/llama-parse', args)

export const makeDomainStandard = args => instance.post('/domain/maker', args)

const gecMlInstance = axios.create({
  baseURL: process.env.VUE_APP_GEC_ML_API,
  headers: { 'Content-Type': 'multipart/form-data' },
})

export const parsePdfFileFromGecMl = params => {
  const formData = new FormData()
  formData.append('pdf_file', params.pdf_file)
  return gecMlInstance.post('/pdf-parser/md/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
